/* ============================================================
   Piemonte Holiday Box — piemonte-box.js
   ============================================================ */
(function () {
  'use strict';

  // ── Gallery ────────────────────────────────────────────────
  var gallery = document.querySelector('[data-pb-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-pb-gallery-main] img');
    var thumbs  = gallery.querySelectorAll('[data-pb-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src    = thumb.getAttribute('data-pb-src');
          mainImg.srcset = thumb.getAttribute('data-pb-srcset') || '';
          mainImg.alt    = thumb.getAttribute('data-pb-alt') || '';
        }
      });
    });
  }

  // ── Shared references ──────────────────────────────────────
  var variantCards    = document.querySelectorAll('[data-pb-variant-card]');
  var variantInput    = document.querySelector('[data-pb-variant-input]');
  var atcBtn          = document.querySelector('[data-pb-atc-btn]');
  var stickyBtn       = document.querySelector('[data-pb-sticky-btn]');
  var stickyPrice     = document.querySelector('[data-pb-sticky-price]');
  var stickyTitle     = document.querySelector('[data-pb-sticky-title]');
  var priceDisplay    = document.querySelector('[data-pb-price-display]');
  var discountPriceEl = document.querySelector('[data-pb-discount-price]');
  var discountBadge   = document.querySelector('[data-pb-discount-amount]');

  function formatBtnText(title, price) {
    return 'Bestel de ' + title + ' · ' + price;
  }

  // ── Variant cards ──────────────────────────────────────────
  variantCards.forEach(function (card) {
    card.addEventListener('click', function () {
      variantCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      var variantId    = card.getAttribute('data-pb-variant-id');
      var variantTitle = card.getAttribute('data-pb-variant-title');
      var priceText    = card.getAttribute('data-pb-price');
      var rawPrice     = parseInt(card.getAttribute('data-pb-raw-price'), 10);

      if (variantInput)  variantInput.value = variantId;
      if (priceDisplay)  priceDisplay.textContent = priceText;
      if (stickyPrice)   stickyPrice.textContent  = priceText;
      if (stickyTitle)   stickyTitle.textContent  = variantTitle;

      var btnText = formatBtnText(variantTitle, priceText);
      if (atcBtn)    atcBtn.textContent    = btnText;
      if (stickyBtn) stickyBtn.textContent = btnText;

      // Show/hide variant full description
      document.querySelectorAll('[data-pb-full-desc]').forEach(function (desc) {
        desc.style.display = desc.getAttribute('data-pb-full-desc') === variantId ? 'block' : 'none';
      });

      // Update discount price
      if (discountPriceEl && discountBadge) {
        var discountAmt = parseInt(discountBadge.getAttribute('data-pb-discount-amount'), 10) * 100;
        var discounted  = rawPrice - discountAmt;
        discountPriceEl.textContent = '€' + Math.floor(discounted / 100);
      }
    });
  });

  // ── Qty stepper ────────────────────────────────────────────
  var qtyDec   = document.querySelector('[data-pb-qty-dec]');
  var qtyInc   = document.querySelector('[data-pb-qty-inc]');
  var qtyVal   = document.querySelector('[data-pb-qty-val]');
  var qtyInput = document.querySelector('[data-pb-qty-input]');

  function setQty(n) {
    var clamped = Math.max(1, Math.min(20, n));
    if (qtyVal)   qtyVal.textContent = clamped;
    if (qtyInput) qtyInput.value     = clamped;
  }

  if (qtyDec) qtyDec.addEventListener('click', function () {
    setQty((parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) - 1);
  });
  if (qtyInc) qtyInc.addEventListener('click', function () {
    setQty((parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) + 1);
  });

  // ── Gift checkbox ──────────────────────────────────────────
  var giftCheckbox = document.querySelector('[data-pb-gift-checkbox]');
  var giftMsgWrap  = document.querySelector('[data-pb-gift-msg-wrap]');

  if (giftCheckbox && giftMsgWrap) {
    giftCheckbox.addEventListener('change', function () {
      if (giftCheckbox.checked) {
        giftMsgWrap.classList.add('is-visible');
      } else {
        giftMsgWrap.classList.remove('is-visible');
      }
    });
  }

  // ── "Bestel als cadeau" button in gift/business section ────
  document.querySelectorAll('[data-pb-gift-scroll-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector('[data-pb-form-sentinel]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      // After scroll, tick the gift checkbox
      setTimeout(function () {
        if (giftCheckbox && !giftCheckbox.checked) {
          giftCheckbox.checked = true;
          giftCheckbox.dispatchEvent(new Event('change'));
        }
      }, 600);
    });
  });

  // ── Sticky bar ─────────────────────────────────────────────
  var stickyBar    = document.querySelector('[data-pb-sticky]');
  var formSentinel = document.querySelector('[data-pb-form-sentinel]');

  if (stickyBar && formSentinel && 'IntersectionObserver' in window) {
    var stickyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    stickyObs.observe(formSentinel);
  }

  // ── Scroll-to-form ─────────────────────────────────────────
  document.querySelectorAll('[data-pb-scroll-to-form]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector('[data-pb-form-sentinel]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  // ── ATC ────────────────────────────────────────────────────
  var atcForm  = document.querySelector('[data-pb-atc-form]');
  var atcError = document.querySelector('[data-pb-atc-error]');

  function doAddToCart() {
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    var qty       = qtyInput     ? parseInt(qtyInput.value, 10) : 1;

    if (!variantId) {
      if (atcError) atcError.textContent = 'Selecteer eerst een box.';
      return;
    }

    if (atcBtn)   { atcBtn.disabled   = true; atcBtn.textContent   = 'Bezig…'; }
    if (stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Bezig…'; }
    if (atcError) atcError.textContent = '';

    var item = { id: variantId, quantity: qty };

    var giftMsgTextarea = document.querySelector('[data-pb-gift-msg-text]');
    if (giftCheckbox && giftCheckbox.checked) {
      var props = { 'Cadeau': 'Ja' };
      if (giftMsgTextarea && giftMsgTextarea.value.trim()) {
        props['Tekst voor het kaartje'] = giftMsgTextarea.value.trim();
      }
      item.properties = props;
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: [item] }),
    })
      .then(function (res) {
        return res.ok ? res.json() : res.json().then(function (d) {
          throw new Error(d.description || 'Er is iets misgegaan.');
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        var selectedCard = document.querySelector('[data-pb-variant-card].is-selected');
        var currentTitle = selectedCard ? selectedCard.getAttribute('data-pb-variant-title') : '';
        var currentPrice = selectedCard ? selectedCard.getAttribute('data-pb-price') : '';
        var restoreText  = currentTitle ? formatBtnText(currentTitle, currentPrice) : 'Bestel nu';
        if (atcBtn)   { atcBtn.disabled   = false; atcBtn.textContent   = restoreText; }
        if (stickyBtn){ stickyBtn.disabled = false; stickyBtn.textContent = restoreText; }
        if (atcError) atcError.textContent = err.message || 'Er is iets misgegaan. Probeer het opnieuw.';
      });
  }

  if (atcForm) {
    atcForm.addEventListener('submit', function (e) { e.preventDefault(); doAddToCart(); });
  }
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () { doAddToCart(); });
  }

})();
